import { inject, injectable, interfaces } from 'inversify';
import { IConfiguration } from '../../configuration/config.types';
import { ICurrentWorkspaceStore } from '../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { IAuthStore } from '../modules/auth/auth.store';
import { IApiPolicyProvider } from './api.policy';
import { ApiServiceBase, IApiService } from './api.service.base';
import { ICacheManager } from './cacheManager';
import { ICryptoService } from './crypto.service';

export type IApiServiceExport = IApiService;

export namespace IApiServiceExport {
  export const $: interfaces.ServiceIdentifier<IApiServiceExport> = Symbol('API_SERVICE_EXPORT');
}

@injectable()
export class ApiServiceExport extends ApiServiceBase implements IApiServiceExport {
  constructor(
    @inject(IConfiguration.$) public readonly config: IConfiguration,
    @inject(IAuthStore.$) protected readonly authStore: IAuthStore,
    @inject(ICurrentWorkspaceStore.$) protected readonly currentWorkspaceStore: ICurrentWorkspaceStore,
    @inject(IApiPolicyProvider.$) protected readonly apiPolicy: IApiPolicyProvider,
    @inject(ICacheManager.$) protected readonly cacheManager: ICacheManager,
    @inject(ICryptoService.$) protected readonly cryptoService: ICryptoService
  ) {
    super(config, authStore, currentWorkspaceStore, apiPolicy, cacheManager, cryptoService);
  }

  public getUrl = (urlSuffix: string): string => this.config.appConfig.exportApiBaseUrl + urlSuffix;
}
